import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ChatStatus } from 'src/shared/stores/chat/chat-data.store';
import { VetCareServiceCardComponent } from '../vet-care-service-card/vet-care-service-card.component';

@Component({
  selector: 'app-chat-type-selection-dialog',
  imports: [VetCareServiceCardComponent],
  templateUrl: './chat-type-selection-dialog.component.html',
  styleUrl: './chat-type-selection-dialog.component.scss',
})
export class ChatTypeSelectionDialogComponent {
  data = inject(DIALOG_DATA);
  dialogRef = inject(DialogRef);
  chatStatusEnum = ChatStatus;

  onChatCardClick(status: ChatStatus) {
    this.dialogRef.close(status);
  }
}
